const products = {
    title: 'Prodotti Tipici Abruzzesi',
    subtitle: 'Scopri i sapori autentici della nostra regione',
    errorLoading: 'Errore nel caricamento dei prodotti',
    loginRequired: 'Effettua il login per aggiungere prodotti al carrello',
    addedToCart: 'Prodotto aggiunto al carrello!',
    errorAddingToCart: 'Errore nell\'aggiunta al carrello',
    noImage: 'Nessuna immagine disponibile',
    inStock: 'Disponibile',
    outOfStock: 'Esaurito',
    loginToAdd: 'Accedi per aggiungere',
    adding: 'Aggiungendo...',
    addToCart: 'Aggiungi al carrello',
    noProducts: 'Nessun prodotto disponibile',
    comingSoon: 'Prodotti deliziosi in arrivo presto nel nostro negozio',
    categories: {
        cheese: 'Formaggi',
        wine: 'Vini',
        oliveOil: 'Olio d\'oliva',
        pasta: 'Pasta',
        salami: 'Salumi',
        honey: 'Miele',
        truffle: 'Tartufi'
    },
    wine: {
        montepulciano: {
            name: 'Montepulciano d\'Abruzzo DOC',
            description: 'Vino rosso corposo e strutturato, prodotto con uve Montepulciano coltivate sulle colline abruzzesi. Note di frutti rossi maturi e spezie dolci, perfetto per accompagnare carni rosse e formaggi stagionati.'
        },
        trebbiano: {
            name: 'Trebbiano d\'Abruzzo DOC',
            description: 'Vino bianco DOC prodotto con uve Trebbiano. Fresco e aromatico, perfetto per i piatti di pesce.'
        }
    },
    cheese: {
        pecorino: {
            name: 'Pecorino Romano DOP',
            description: 'Formaggio pecorino stagionato prodotto in Abruzzo secondo la tradizione secolare. Sapore intenso e aromatico.'
        },
        caciocavallo: {
            name: 'Caciocavallo Silano',
            description: 'Formaggio a pasta filata prodotto con latte di vacca. Sapore dolce e consistenza elastica.'
        }
    },
    oliveOil: {
        extraVergine: {
            name: 'Olio Extra Vergine di Oliva',
            description: 'Olio extra vergine di oliva biologico prodotto da olive coltivate in Abruzzo. Fruttato e leggermente piccante.'
        }
    },
    pasta: {
        chitarra: {
            name: 'Pasta alla Chitarra',
            description: 'Pasta tradizionale abruzzese fatta a mano con farina di grano duro e uova. Formato caratteristico a sezione quadrata.'
        },
        lenticchie: {
            name: 'Lenticchie di Santo Stefano',
            description: 'Lenticchie coltivate nell\'altopiano di Santo Stefano di Sessanio. Piccole e saporite.'
        }
    },
    salami: {
        salsiccia: {
            name: 'Salsiccia di Fegato',
            description: 'Salsiccia tradizionale abruzzese preparata con fegato di maiale e spezie. Sapore intenso e caratteristico.'
        }
    },
    honey: {
        castagno: {
            name: 'Miele di Castagno',
            description: 'Miele monoflora di castagno prodotto in montagna. Sapore intenso e colore scuro caratteristico.'
        }
    },
    truffle: {
        nero: {
            name: 'Tartufo Nero',
            description: 'Tartufo nero pregiato raccolto nei boschi abruzzesi. Aroma intenso e sapore inconfondibile.'
        }
    }
};

export default products;
